import {
  AppConfig,
  AppConfigService,
} from '@core/services/config/app-config.service';
import { Action, createAction, createReducer, on, props } from '@ngrx/store';
import { FeatureFlags } from '@app/generated/feature-flags.types';

export const runtimeFeatureFlagsLoaded = createAction(
  '[Runtime Feature Flags] Snapshot Loaded',
  props<{ values: Partial<FeatureFlags> }>()
);

const runtimeConfigReducer = createReducer(
  {} as AppConfig,
  on(
    runtimeFeatureFlagsLoaded,
    (state: AppConfig, { values }): AppConfig => ({
      ...state,
      ...values,
    })
  )
);

export const configReducer = (
  state: AppConfig | undefined,
  action: Action
): AppConfig =>
  runtimeConfigReducer(state ?? { ...AppConfigService.staticConfig }, action);
